console.log('Property Modifiers JS Loading...');

class PropertyModifiers {
  constructor(container) {
    console.log('PropertyModifiers constructor called', container);
    this.container = container;
    this.data = this.parseData();
    this.currentModifications = {};
    this.originalCompareAtPrice = null;
    
    if (!this.data) {
      console.log('No data found, exiting');
      return;
    }
    
    console.log('Parsed data:', this.data);
    this.init();
  }

  parseData() {
    const dataScript = this.container.querySelector('[data-modifiers-data]');
    if (!dataScript) {
      console.log('No data script found');
      return null;
    }
    
    try {
      const data = JSON.parse(dataScript.textContent);
      console.log('Successfully parsed data:', data);
      return data;
    } catch (e) {
      console.error('Error parsing modifiers data:', e);
      return null;
    }
  }

  init() {
    console.log('Initializing PropertyModifiers...');
    this.captureOriginalPrices();
    this.setupEventListeners();
    this.initializeDefaultValues();
  }

  captureOriginalPrices() {
    // Capture the original compare-at price if it exists
    const oldPriceElement = document.querySelector('.f8pr-price .old-price, .m6pr .old-price');
    if (oldPriceElement && oldPriceElement.textContent.trim()) {
      // Extract the numeric value from the compare-at price
      const priceText = oldPriceElement.textContent.replace(/[^0-9.]/g, '');
      this.originalCompareAtPrice = parseFloat(priceText) * 100; // Convert to cents
      console.log('Captured original compare-at price:', this.originalCompareAtPrice);
    } else {
      console.log('No compare-at price found');
    }
  }

  setupEventListeners() {
    console.log('Setting up event listeners...');
    
    // Radio button changes
    const radioInputs = this.container.querySelectorAll('input[data-property-type="radio"]');
    console.log('Found radio inputs:', radioInputs.length);
    radioInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        console.log('Radio changed:', e.target);
        this.handleRadioChange(e);
      });
    });

    // Checkbox changes
    const checkboxInputs = this.container.querySelectorAll('input[data-property-type="boolean"]');
    console.log('Found checkbox inputs:', checkboxInputs.length);
    checkboxInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        console.log('Checkbox changed:', e.target);
        this.handleBooleanChange(e);
      });
    });
  }
initializeDefaultValues() {
  console.log('Initializing default values...');
  this.container.querySelectorAll('input[data-property-type="radio"]:checked').forEach(input => {
    const amount = parseFloat(input.dataset.priceIncrease) || 0;
    const propertyName = input.dataset.propertyName;
    console.log('Default radio checked:', propertyName, amount);
    this.updateAmount(propertyName, amount); // ← call updateAmount() instead
  });
}



  handleRadioChange(e) {
    const input = e.target;
    const amount = parseFloat(input.dataset.priceIncrease) || 0;
    const propertyName = input.dataset.propertyName;
    
    console.log('handleRadioChange:', propertyName, amount);
    this.updateAmount(propertyName, amount);
  }

  handleBooleanChange(e) {
    const input = e.target;
    const amount = input.checked ? (parseFloat(input.dataset.priceIncrease) || 0) : 0;
    const propertyName = input.dataset.propertyName;
    
    console.log('handleBooleanChange:', propertyName, amount, 'checked:', input.checked);
    this.updateAmount(propertyName, amount);
  }

  updateAmount(propertyName, dollarAmount) {
    console.log('updateAmount called:', propertyName, dollarAmount);
    
    // Update the individual amount input
    const individualInput = this.container.querySelector(`[data-amount-input-for="${propertyName}"]`);
    if (individualInput) {
      individualInput.value = dollarAmount;
      console.log('Updated individual input:', individualInput.value);
    }

    // Update our tracking object
    this.currentModifications[propertyName] = dollarAmount;
    console.log('Current modifications:', this.currentModifications);

    // Calculate total and update aggregated input
    const totalAmount = this.calculateTotalAmount();
    console.log('Total amount:', totalAmount);
    
    const totalInput = this.container.querySelector('[data-total-warranty-amount]');
    if (totalInput) {
      totalInput.value = totalAmount.toFixed(2);
      console.log('Updated total input:', totalInput.value);
    }

    // Update the displayed price
    this.updateTotalPrice(totalAmount);
  }

  calculateTotalAmount() {
    const total = Object.values(this.currentModifications).reduce((sum, val) => sum + val, 0);
    console.log('calculateTotalAmount:', total);
    return total;
  }

  updateTotalPrice(totalAmount = null) {
    if (totalAmount === null) {
      totalAmount = this.calculateTotalAmount();
    }

    const basePrice = this.data.basePrice;
    const newPrice = basePrice + (totalAmount * 100); // Convert dollars to cents

    console.log('updateTotalPrice:', {
      basePrice,
      totalAmount,
      newPrice
    });

    // Calculate new compare-at price if it exists
    let newCompareAtPrice = null;
    if (this.originalCompareAtPrice) {
      newCompareAtPrice = this.originalCompareAtPrice + (totalAmount * 100);
      console.log('New compare-at price:', newCompareAtPrice);
    }

    // Update all price displays
    this.updatePriceDisplays(newPrice, newCompareAtPrice);
  }

  updatePriceDisplays(newPriceCents, newCompareAtPriceCents = null) {
    const formattedPrice = this.formatMoney(newPriceCents);
    console.log('Updating price displays to:', formattedPrice);
    
    // Find the main price container
    const mainPriceContainer = document.querySelector('.f8pr-price, .m6pr .price');
    console.log('Found main price container:', mainPriceContainer);
    
    if (mainPriceContainer) {
      // Update compare-at price first (if it exists)
      if (newCompareAtPriceCents) {
        const formattedCompareAtPrice = this.formatMoney(newCompareAtPriceCents);
        const oldPriceElement = mainPriceContainer.querySelector('.old-price');
        if (oldPriceElement) {
          console.log('Updating compare-at price to:', formattedCompareAtPrice);
          oldPriceElement.textContent = formattedCompareAtPrice;
        }
      }
      
      // Get all child nodes
      const childNodes = Array.from(mainPriceContainer.childNodes);
      console.log('Child nodes:', childNodes);
      
      // Find text nodes or spans that aren't .old-price
      childNodes.forEach(node => {
        // Text node
        if (node.nodeType === 3 && node.textContent.trim().length > 0) {
          console.log('Found text node:', node.textContent);
          if (node.textContent.includes('$') || node.textContent.match(/[0-9]/)) {
            console.log('Updating text node to:', formattedPrice);
            node.textContent = ' ' + formattedPrice;
          }
        }
        // Element node that's not old-price
        else if (node.nodeType === 1 && !node.classList.contains('old-price')) {
          console.log('Found element node:', node);
          if (node.textContent.includes('$') || node.textContent.match(/[0-9]/)) {
            console.log('Updating element to:', formattedPrice);
            node.textContent = formattedPrice;
          }
        }
      });
      
      // Also try looking for dd, .price-item, or other direct children
      const priceElements = mainPriceContainer.querySelectorAll('dd:not(.old-price), span:not(.old-price), [class*="price"]:not(.old-price)');
      console.log('Found non-old-price elements:', priceElements);
      priceElements.forEach(el => {
        if (el.textContent.includes('$') || el.textContent.match(/[0-9]/)) {
          console.log('Updating:', el, 'to:', formattedPrice);
          el.textContent = formattedPrice;
        }
      });
    }

    // Also update sticky cart if present
    const stickyPrice = document.querySelector('#sticky-add-to-cart .price:not(.old-price)');
    if (stickyPrice) {
      console.log('Updating sticky price');
      stickyPrice.textContent = formattedPrice;
    }

    // Update sticky compare-at price if present
    if (newCompareAtPriceCents) {
      const formattedCompareAtPrice = this.formatMoney(newCompareAtPriceCents);
      const stickyOldPrice = document.querySelector('#sticky-add-to-cart .old-price');
      if (stickyOldPrice) {
        console.log('Updating sticky compare-at price');
        stickyOldPrice.textContent = formattedCompareAtPrice;
      }
    }
  }

  formatMoney(cents) {
    const format = this.data.currencyFormat || '{{amount}}';
    const value = (cents / 100).toFixed(0);
    
    console.log('formatMoney:', cents, format, value);
    
    if (format.includes('{{amount}}')) {
      return format.replace('{{amount}}', value);
    } else if (format.includes('{{amount_no_decimals}}')) {
      return format.replace('{{amount_no_decimals}}', Math.round(cents / 100));
    } else if (format.includes('{{amount_with_comma_separator}}')) {
      return format.replace('{{amount_with_comma_separator}}', value.replace('.', ','));
    }
    
    return `$${value}`;
  }
}

// Initialize immediately if DOM is ready
function initPropertyModifiers() {
  console.log('initPropertyModifiers called');
  const containers = document.querySelectorAll('[data-property-modifiers]');
  console.log('Found containers:', containers.length);
  
  containers.forEach(container => {
    console.log('Initializing container:', container);
    new PropertyModifiers(container);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPropertyModifiers);
} else {
  initPropertyModifiers();
}


// Ensure warranty amount is correct at form submission time
document.addEventListener('submit', function(e) {
  const form = e.target;
  document.querySelectorAll('[data-property-modifiers]').forEach(function(container) {
    // For each modifier, re-read the checked radio and update the hidden inputs
    container.querySelectorAll('input[data-property-type="radio"]:checked').forEach(function(checked) {
      const propertyName = checked.dataset.propertyName;
      const amount = parseFloat(checked.dataset.priceIncrease) || 0;

      // Update individual amount input
      const individualInput = container.querySelector('[data-amount-input-for="' + propertyName + '"]');
      if (individualInput) {
        const inputForm = individualInput.getAttribute('form');
        if (!inputForm || document.getElementById(inputForm) === form) {
          individualInput.value = amount;
        }
      }
    });

    // Update total warranty amount
    const totalInput = container.querySelector('[data-total-warranty-amount]');
    if (totalInput) {
      const totalForm = totalInput.getAttribute('form');
      if (!totalForm || document.getElementById(totalForm) === form) {
        const total = Array.from(container.querySelectorAll('input[data-property-type="radio"]:checked'))
          .reduce(function(sum, input) {
            return sum + (parseFloat(input.dataset.priceIncrease) || 0);
          }, 0);
        totalInput.value = total.toFixed(2);
      }
    }
  });
}, true); // capture phase — runs before form submits


console.log('Property Modifiers JS Loaded');